/** Citation rows shown under Quellen; keep in sync with tri-server utilities/bpmResourceMerge.isSourceResource */
export function isSourceResource(r: unknown): boolean {
  const x = r as { type?: string } | null | undefined;
  return !!(x && (x.type === 'source' || x.type === 'Source'));
}

/**
 * Das ganze Regelwerk zu einem Normtext-Fragment — für den Dokumentbetrachter, der beim Fragment
 * auch den Weg zum Ganzen zeigen soll (30.09.2026).
 *
 * Der Server legt zu jedem Fragment (`regulationId`) eine zweite Quelle fürs ganze Regelwerk in
 * dieselbe Antwort (`sourceType: 'regulation'`, tri-server `withWholeWorkSources`): die amtliche
 * Fassung, sonst den Herausgeber — beides eine Webseite — oder, wenn es keins gibt, unseren
 * Gesamttext (`referenceKind: 'wholeText'`, eine Datei). `undefined`, wenn nichts dazu passt.
 */
export interface WholeWorkReference {
  label: string;
  /** Eine Webseite (amtliche Fassung, Herausgeber). */
  url?: string;
  /** Unser Gesamttext — öffnet im Betrachter. */
  fileId?: string;
}

export function wholeWorkReferenceOf(source: any, all: any[]): WholeWorkReference | undefined {
  if (!source?.regulationId || source.sourceType === 'regulation') return undefined;
  const whole = (all || []).find(
    (s: any) => s && s !== source && s.sourceType === 'regulation' && s.regulationId === source.regulationId
  );
  if (!whole) return undefined;
  const label = String(whole.document || whole.regulationId);
  if (whole.referenceKind === 'wholeText' && whole.documentId) return { label, fileId: String(whole.documentId) };
  if (/^https?:\/\//i.test(String(whole.url || ''))) return { label, url: String(whole.url) };
  return undefined;
}
